import { getSingleHistory } from "../../data/dataApi";
import ContentWrapper from "../../views/components/ContentWrapper";
import { useEffect, useState } from 'react';
import { useParams, Link, useNavigate, useLocation } from 'react-router-dom';
import React from 'react';

const SingleHistory = () => {
    const [chatHistory, setChatHistory] = useState([]);
    const [sessionAccounts, setSessionAccounts] = useState([]);
    const { sessionId } = useParams();
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        (async () => {
            const response = await getSingleHistory(sessionId);
                        
            if(response.success) {
                const { rows } = response.data;
                setChatHistory(rows);

                const accounts = rows.filter(row => row.account !== null).map(row => JSON.parse(row.account));
                setSessionAccounts(new Set(accounts));
            }
        })();
    }, [sessionId]);

    return (
        <ContentWrapper className="scrollable">
            <div className="back-wrapper">
                <button className="tertiary-btn tif-mb-10"
                    onClick={() => {
                        if (location.key === 'default') {
                            navigate('/history')
                        } else {
                            navigate(-1)
                        }
                    }}>
                    Back
                </button>
            </div>
            <div className="wrapper tif-bg-color-alpha tif-bg-light-color-white">
                    {
                        sessionAccounts.size ?
                            <div className="tif-mb-30">
                                <h2 className="tif-h3">Account Details</h2>
                                {
                                    Array.from(sessionAccounts).map((account, index) => (
                                        <ul key={index}>
                                            <li>
                                                <span className="bold">Deacom ID:</span> {account.deacom_id || "Undefined"}
                                            </li>
                                            <li>
                                                <span className="bold">Wordpress ID:</span> {account.wordpress_id}
                                            </li>
                                            <li>
                                                <span className="bold">Email:</span> {account.email}
                                            </li>
                                        </ul>
                                    ))
                                }
                            </div>
                        :
                            <></>
                    }
                <div className="table-wrapper">
                    <table className="secondary-table w-100">
                        <thead>
                            <tr>
                                <td>Sender</td>
                                <td>Message</td>
                                <td style={{ width: "20%" }}>Source&nbsp;Documents</td>
                                <td style={{ width: "20%" }}>Origin URL</td>
                            </tr>
                        </thead>
                        
                        {chatHistory.map((history, index) => (
                            <React.Fragment key={index}>
                                <tbody>
                                    <tr className="spacer-row" key={`${index}-0`}>
                                        <td colSpan="3"></td>
                                    </tr>
                                </tbody>
                                <tbody className="secondary-body">
                                    <tr className="first-row" key={`${index}-1`}>
                                        <td>User</td>
                                        <td>{history.user_message}</td>
                                        <td></td>
                                        <td><a className="link-out" href={history.origin} target="_blank">{history.origin}</a></td>
                                    </tr>
                                    <tr className="second-row" key={`${index}-2`}>
                                        <td>Chatbot</td>
                                        <td dangerouslySetInnerHTML={{ __html: history.api_response }}></td>
                                        <td>
                                            <ul>
                                                {history.source_docs ? (
                                                    JSON.parse(history.source_docs).map((item, index) => {
                                                        if(item.metadata) {
                                                            const { filename } = item.metadata;

                                                            return (
                                                                <li key={index}>
                                                                    <Link to={ item.metadata.source_url } target="_blank" className="link-out">{filename}</Link>
                                                                </li>
                                                            );
                                                        } else {
                                                            return (
                                                                <li key={index}>
                                                                    <Link to={ item } target="_blank" className="link-out">{item}</Link>
                                                                </li>
                                                            );
                                                        }
                                                    })
                                                ) : (
                                                    <span className="no-docs tif-color-hotel">n/a</span>
                                                )}
                                            </ul>
                                        </td>
                                        <td></td>
                                    </tr>
                                </tbody>

                            </React.Fragment>
                        ))}
                    </table>
                </div>
            </div>
        </ContentWrapper>
    );
}

export default SingleHistory;